<template>
    <!-- <button
        style="background-color:#6772E5;color:#FFF;padding:8px 12px;border:0;border-radius:4px;font-size:1em"
        id="checkout-button-price_1HCfhTCI5H9rc0EdjKx0BZ3w"
        role="link"
        type="button"
        @click="main">
        Checkout
    </button> -->
    <div></div>
</template>

<script>
export default {
    mounted(){
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://js.stripe.com/v3')
        document.head.appendChild(recaptchaScript)
        var stripe = Stripe('pk_test_WIqtlvIHuw0DVYa5hvjuGnPY00V521yt2P')
        var response = fetch('http://localhost:5001/svcamp-6d3c3/us-central1/id').then(function(response) {
            return response.json();
        }).then(function(responseJson) {
            var sessionID = responseJson.session_id;
            console.log(sessionID)
            // Call stripe.redirectToCheckout() with the Session ID.
            stripe.redirectToCheckout({
                sessionId: sessionID
            })
        });
    },
    methods: {
        main(){
            var stripe = Stripe('pk_test_WIqtlvIHuw0DVYa5hvjuGnPY00V521yt2P');
            console.log(stripe)
            stripe.redirectToCheckout({
                lineItems: [{price: 'price_1HCfhTCI5H9rc0EdjKx0BZ3w', quantity: 1}],
                mode: 'payment',
                successUrl: window.location.protocol + '//sv.camp/success',
                cancelUrl: window.location.protocol + '//sv.camp/canceled',
            }).then(function(result){
                console.log("ERROR")
                var displayError = document.getElementById('error-message');
                displayError.textContent = result.error.message;
            })
        }
    }
}
</script>
